import React, { useRef } from "react";
import { useCustomQuery } from "utilities/hookutils";
import { LegacyErrorHandling, useValidate } from "formvalidation/hooks";
import { CommonInputProps } from "./WithErrorLabel/models";
import { InputBase } from "components/Atoms/formInputs/InputBase";

interface Props extends CommonInputProps {
  error?: LegacyErrorHandling
  noErrorText?: boolean
}

const UsernameInput = (props: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const validateUsernameApi = useCustomQuery({
    queryKey: ["validateUsername", props.value],
    queryFn: () => window.CoreApi.Register.ValidateUsername(props.value).then(r => r.data),
    staleTime: 1000 * 60 * 60, // cache result for 1 hour
    enabled: false
  });

  const validate = async () => {
    if (props.value.trim() === "") {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }

    const result = await validateUsernameApi.refetch();

    return result.data.isValidFormattingAndUnique;
  }

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.SoUser.Username,
    value: props.value,
    validate: validate,
    ref: inputRef,
    legacyError: props.error,
    type: "manual"
  })

  const onSuggestionSelect = async () => {
    props.onChange(validateUsernameApi.data.suggestion);
    validation.setError({ hasError: false });
  };

  const displayErrors = props.noErrorText !== true;

  return <>
    <InputBase
      ref={inputRef}
      loading={validateUsernameApi.isFetching}
      error={validation.error.hasError}
      value={props.value}
      onChange={value => { props.onChange(value); }}
      onBlur={validation.validateAndSetError}
      maxLength={serverReference.constants.user.maxUsernameLength}
    />
    {(typeof validation.error.errorMessage && displayErrors) && <div className="s1_red">{validation.error.errorMessage}</div>}
    {validateUsernameApi.data != null && !validateUsernameApi.data.isValidFormattingAndUnique && <div className="s1_red">
      {validateUsernameApi.data.message}
    </div>}
    {validateUsernameApi.data?.suggestion && <div>
      Suggestion: <a onClick={onSuggestionSelect}>
        {validateUsernameApi.data.suggestion}
      </a>
    </div>}
  </>;
};

export default UsernameInput;